// components/Contact.jsx
import React, { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    phoneNumber: '',
    email: '',
    testRequired: '',
    preferredDate: '',
    sampleCollection: 'Visit Center',
    additionalNotes: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = () => {
    // Validate required fields
    if (!formData.fullName || !formData.phoneNumber || !formData.testRequired || !formData.preferredDate) {
      alert('Please fill in all required fields (*)');
      return;
    }

    setIsSubmitting(true);

    // Format the message for WhatsApp
    const message = `*SRM Diagnostic Center - New Test Booking*%0a%0a
*Patient Details:*%0a
👤 *Name:* ${formData.fullName}%0a
📞 *Phone:* ${formData.phoneNumber}%0a
✉️ *Email:* ${formData.email || 'Not provided'}%0a%0a

*Test Details:*%0a
🔬 *Test Required:* ${formData.testRequired}%0a
📅 *Preferred Date:* ${formData.preferredDate}%0a
🏠 *Sample Collection:* ${formData.sampleCollection}%0a%0a

*Additional Information:*%0a
📝 *Notes:* ${formData.additionalNotes || 'No additional notes'}%0a%0a
---%0a
_Booking requested via SRM Diagnostic Website_`;

    // WhatsApp number (without + sign)
    const phoneNumber = '9149322973';
    
    // Create WhatsApp URL
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
    
    // Open WhatsApp in a new tab
    window.open(whatsappUrl, '_blank');
    
    // Reset submitting state after a short delay
    setTimeout(() => {
      setIsSubmitting(false);
    }, 1000);
  };

  return (
    <section id="contact" className="py-20 px-8 bg-cream">
      <div className="max-w-[1200px] mx-auto">
        <p className="text-teal text-[0.75rem] font-semibold tracking-[2px] uppercase mb-3">Get in Touch</p>
        <h2 className="text-4xl md:text-5xl text-charcoal font-serif mb-4">Visit or Book a Test</h2>
        <p className="text-[#5a7a77] max-w-md leading-relaxed">Walk in anytime or schedule a test in advance. We are conveniently located on GMS Road, Dehradun.</p>

        <div className="grid md:grid-cols-2 gap-16 mt-12 items-start">
          <div>
            <div className="flex gap-4 mb-6">
              <div className="w-11 h-11 bg-teal-light rounded-xl flex items-center justify-center shrink-0">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0f7a6e" strokeWidth="2" strokeLinecap="round">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/>
                </svg>
              </div>
              <div>
                <h4 className="text-[0.82rem] font-semibold uppercase tracking-wide text-[#7a9490] mb-0.5">Address</h4>
                <p className="text-sm text-charcoal leading-relaxed">SRM Diagnostic Center<br/>Sevla Kala, Near Keshav Medical Center<br/>GMS Road, Dehradun, Uttarakhand</p>
              </div>
            </div>
            <div className="flex gap-4 mb-6">
              <div className="w-11 h-11 bg-teal-light rounded-xl flex items-center justify-center shrink-0">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0f7a6e" strokeWidth="2" strokeLinecap="round">
                  <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 8.81 19.79 19.79 0 01.01 2.18 2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
                </svg>
              </div>
              <div>
                <h4 className="text-[0.82rem] font-semibold uppercase tracking-wide text-[#7a9490] mb-0.5">Phone</h4>
                <p className="text-sm text-charcoal">+91 91493 22973</p>
              </div>
            </div>
            <div className="flex gap-4 mb-6">
              <div className="w-11 h-11 bg-teal-light rounded-xl flex items-center justify-center shrink-0">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0f7a6e" strokeWidth="2" strokeLinecap="round">
                  <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
                </svg>
              </div>
              <div>
                <h4 className="text-[0.82rem] font-semibold uppercase tracking-wide text-[#7a9490] mb-0.5">Working Hours</h4>
                <p className="text-sm text-charcoal">Monday – Sunday<br/>7:00 AM – 8:00 PM</p>
              </div>
            </div>
            <div className="flex gap-4 mb-6">
              <div className="w-11 h-11 bg-teal-light rounded-xl flex items-center justify-center shrink-0">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0f7a6e" strokeWidth="2" strokeLinecap="round">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/>
                </svg>
              </div>
              <div>
                <h4 className="text-[0.82rem] font-semibold uppercase tracking-wide text-[#7a9490] mb-0.5">Email</h4>
                <p className="text-sm text-charcoal">srmpathologyddn@gmail.com</p>
              </div>
            </div>

            {/* WhatsApp Direct Contact Button */}
            <div className="mt-8">
              <a 
                href="https://wa.me/9149322973" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 w-full bg-[#25D366] text-white py-3 px-4 rounded-xl font-semibold text-sm hover:bg-[#128C7E] transition-colors"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>
                </svg>
                Chat with us on WhatsApp
              </a>
            </div>

            <div className="bg-[#e8f5f3] rounded-2xl h-[260px] flex flex-col items-center justify-center border-2 border-dashed border-[#b2d9d4] gap-2 mt-6">
              <div className="text-3xl">📍</div>
              <p className="font-semibold text-charcoal">Sevla Kala, GMS Road</p>
              <p className="text-sm text-[#4a7570]">Near Keshav Medical Center, Dehradun</p>
              <a href="https://maps.google.com?q=Sevla+Kala+GMS+Road+Dehradun" target="_blank" rel="noopener noreferrer" className="mt-2 text-sm text-teal font-semibold border border-teal py-1.5 px-4 rounded-lg hover:bg-teal-light transition-colors">Open in Maps →</a>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-10 border border-[#e0eeec]">
            <h3 className="text-charcoal text-xl mb-1">Book a Test</h3>
            <p className="text-sm text-[#7a9490] mb-6">Fill in the details below and we'll confirm your appointment.</p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              <div>
                <label className="block text-[0.82rem] font-semibold text-[#4a6662] mb-1">Full Name *</label>
                <input 
                  type="text" 
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  placeholder="Your name" 
                  className="w-full p-3 border-2 border-[#d5e8e5] rounded-xl text-sm focus:border-teal outline-none transition-colors" 
                />
              </div>
              <div>
                <label className="block text-[0.82rem] font-semibold text-[#4a6662] mb-1">Phone Number *</label>
                <input 
                  type="tel" 
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  placeholder="+91 XXXXX XXXXX" 
                  className="w-full p-3 border-2 border-[#d5e8e5] rounded-xl text-sm focus:border-teal outline-none transition-colors" 
                />
              </div>
            </div>
            
            <div className="mb-4">
              <label className="block text-[0.82rem] font-semibold text-[#4a6662] mb-1">Email Address</label>
              <input 
                type="email" 
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="you@email.com" 
                className="w-full p-3 border-2 border-[#d5e8e5] rounded-xl text-sm focus:border-teal outline-none transition-colors" 
              />
            </div>
            
            <div className="mb-4">
              <label className="block text-[0.82rem] font-semibold text-[#4a6662] mb-1">Test Required *</label>
              <select 
                name="testRequired"
                value={formData.testRequired}
                onChange={handleChange}
                className="w-full p-3 border-2 border-[#d5e8e5] rounded-xl text-sm focus:border-teal outline-none transition-colors"
              >
                <option value="">Select a test or package</option>
                <option>Complete Blood Count (CBC)</option>
                <option>Liver Function Test (LFT)</option>
                <option>Kidney Function Test (KFT)</option>
                <option>Thyroid Profile</option>
                <option>Lipid Profile</option>
                <option>HbA1c</option>
                <option>Blood Glucose Fasting/PP</option>
                <option>Basic Wellness Package</option>
                <option>Comprehensive Health Package</option>
                <option>Other (mention below)</option>
              </select>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              <div>
                <label className="block text-[0.82rem] font-semibold text-[#4a6662] mb-1">Preferred Date *</label>
                <input 
                  type="date" 
                  name="preferredDate"
                  value={formData.preferredDate}
                  onChange={handleChange}
                  className="w-full p-3 border-2 border-[#d5e8e5] rounded-xl text-sm focus:border-teal outline-none transition-colors" 
                />
              </div>
              <div>
                <label className="block text-[0.82rem] font-semibold text-[#4a6662] mb-1">Sample Collection</label>
                <select 
                  name="sampleCollection"
                  value={formData.sampleCollection}
                  onChange={handleChange}
                  className="w-full p-3 border-2 border-[#d5e8e5] rounded-xl text-sm focus:border-teal outline-none transition-colors"
                >
                  <option>Visit Center</option>
                  <option>Home Collection</option>
                </select>
              </div>
            </div>
            
            <div className="mb-6">
              <label className="block text-[0.82rem] font-semibold text-[#4a6662] mb-1">Additional Notes</label>
              <textarea 
                name="additionalNotes"
                value={formData.additionalNotes}
                onChange={handleChange}
                rows="3" 
                placeholder="Any specific instructions or tests not listed above…" 
                className="w-full p-3 border-2 border-[#d5e8e5] rounded-xl text-sm focus:border-teal outline-none transition-colors resize-none"
              ></textarea>
            </div>
            
            <button 
              onClick={handleSubmit} 
              disabled={isSubmitting}
              className={`w-full py-3 rounded-xl text-sm font-semibold transition-all flex items-center justify-center gap-2 ${
                isSubmitting ? 'bg-gray-400 cursor-not-allowed' : 'bg-teal hover:bg-teal-dark'
              } text-white`}
            >
              {isSubmitting ? (
                <>
                  <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Opening WhatsApp...
                </>
              ) : (
                'Confirm Booking →'
              )}
            </button>
            
            <p className="text-xs text-[#7a9490] text-center mt-4">
              By clicking confirm, you'll be redirected to WhatsApp to send your booking details.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;